import styled from '@emotion/styled';
import classNames from 'classnames';
import { LucideIcon } from 'lucide-react';
import React from 'react';
import { theme } from 'styles/theme/theme';

export type UDChipProps = {
  color?: 'yellow' | 'gray' | 'blue' | string;
  size?: number;
  icon?: LucideIcon;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  'aria-label'?: string;
};

const colorMap: Record<string, string> = {
  yellow: theme.colors.AccentNaplesYellow,
  gray: theme.colors.Gray,
  blue: theme.colors.SurfaceRaisinBlack50,
};

const ChipBlock = styled.span<{
  $color: string;
  $size: number;
}>(
  ({ $color, $size }) => `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: ${$color};
    border-radius: 9999px;
    min-width: ${$size}px;
    min-height: ${$size}px;
    width: ${$size}px;
    height: ${$size}px;
    padding: 0;
    font-size: ${Math.round($size * 0.6)}px;
    color: ${theme.colors.SurfaceWhite};
    box-shadow: 0 0 0 1px rgba(0,0,0,0.03);
  `,
);

const UDChip: React.FC<UDChipProps> = ({
  color = 'yellow',
  size = 12,
  icon: Icon,
  className,
  style,
  children,
  'aria-label': ariaLabel,
}) => {
  const resolvedColor = colorMap[color] || color;
  return (
    <ChipBlock
      $color={resolvedColor}
      $size={size}
      className={classNames('ud-chip', className)}
      style={style}
      aria-label={ariaLabel}
      tabIndex={0}
      role="status"
    >
      {Icon && <Icon size={Math.round(size * 0.7)} style={{ marginRight: children ? 4 : 0 }} />}
      {children}
    </ChipBlock>
  );
};

export default UDChip;
